import { render } from "./TenantNav.vue?vue&type=template&id=476470d0&scoped=true"
import script from "./TenantNav.vue?vue&type=script&lang=js"
export * from "./TenantNav.vue?vue&type=script&lang=js"

import "./TenantNav.vue?vue&type=style&index=0&id=476470d0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-476470d0"]])

export default __exports__